import { CommonModule } from '@angular/common';
import { DoBootstrap, NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { AddBusinessManagerComponent } from './add-business-manager/add-business-manager.component';
import { AddCatalogComponent } from './add-catalog/add-catalog.component';
import { BusinessManagerComponent } from './business-manager/business-manager.component';
import { CatalogComponent } from './catalog/catalog.component';
import { CatalogsMainComponent } from './catalogs-main/catalogs-main.component';
import { ConfirmDeletionComponent } from './confirm-deletion/confirm-deletion.component';

@NgModule({
  declarations: [
    AddBusinessManagerComponent,
    CatalogsMainComponent,
    BusinessManagerComponent,
    CatalogComponent,
    AddCatalogComponent,
    ConfirmDeletionComponent,
  ],
  imports: [CommonModule, SharedModule, TranslateModule.forChild()],
})
export class CatalogsModule implements DoBootstrap {
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngDoBootstrap(): void {}
}
